<template>
  <div>
    <div>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-input
            v-model="mpAdvertiserListParams.account_id"
            placeholder="请输入广告账户id"
            rows="8"
          >
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-button
          type="primary"
          @click="searchMpAdvert"
        >搜索
        </el-button>
        <el-button
          type="primary"
          @click="resetMpAdvertList"
        >重置
        </el-button>
        <!-- <el-button
          type="primary"
          @click="clearSelect"
        >清空选项
        </el-button> -->
      </el-row>
    </div>
    <div style="margin: 20px">
      <el-table
        ref="multipleTable"
        :data="mpAdvertiserList"
        border
        tooltip-effect="dark"
      >
        <el-table-column
          label="广告主id"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-checkbox
              v-model="selectedRows"
              :label="row.account_id"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="广告主名称"
        >
          <template scope="scope">
            <p :title="scope.row.company_name">{{ scope.row.company_name }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <PaginationRight
      style="float: left;"
      :total="total"
      :page.sync="mpAdvertiserListParams.page"
      :limit.sync="mpAdvertiserListParams.page_size"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div>
      <el-button
        type="info"
        @click="$emit('close')"
      >取消</el-button>
      <el-button
        type="success"
        @click="commit"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { iqiyiadvertiserlist } from '@/api/massiveAdvertising/accountList.js'
export default {
  components: {
    PaginationRight
  },
  props: {
    account_list: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  data() {
    return {
      total: 0,
      selectedRows: [...this.account_list],
      mpAdvertiserListParams: {
        account_id: null,
        account_name: null,
        page: 1, // 当前页码
        page_size: 10 // 显示数据条数
      },
      mpAdvertiserList: null
    }
  },
  watch: {
    account_list(newVal, oldVal) {
      this.selectedRows = [...newVal]
    }
  },
  created() {
    this.fetchMpAdvertiserList()
  },
  methods: {
    fetchPageSize(e) {
      this.mpAdvertiserListParams.page_size = e
      this.fetchMpAdvertiserList()
    },
    fetchCurrentPage(e) {
      this.mpAdvertiserListParams.page = e
      this.fetchMpAdvertiserList()
    },

    // 获取广告主列表
    fetchMpAdvertiserList() {
      this.isLoading = true
      iqiyiadvertiserlist({
        account_id: this.mpAdvertiserListParams.account_id,
        account_name: this.mpAdvertiserListParams.account_name,
        page: this.mpAdvertiserListParams.page,
        page_size: this.mpAdvertiserListParams.page_size
      }).then(res => {
        this.mpAdvertiserList = res.data.list
        this.total = res.data.total
        this.isLoading = false
      })
    },
    clearSelect() {
      this.$refs.multipleTable.clearSelection()
    },
    searchMpAdvert() {
      this.fetchMpAdvertiserList()
    },
    resetMpAdvertList() {
      this.mpAdvertiserListParams = {
        name: null,
        page: 1,
        page_size: 10
      }
      this.fetchMpAdvertiserList()
    },
    commit() {
      this.$emit('commit', this.selectedRows)
    }
  }
}
</script>

<style lang="less" scoped>
.center-container {
  margin-top: 20px;
  display: flex;

  .input {
    height: 30px;
    width: 69px;
    padding-left: 5px;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
  }
}
</style>
